<div class="dashboard-wrapper">

  <!-- Header -->
  <!-- HEADER -->
  <div class="header-bar exact-header">
    <div class="header-row-flex">

      <!-- Left: Menu + Logo -->
      <div class="d-flex justify-space-between align-items-center">
        <div class="logo-icon" (click)="toggleMenu()">
          <mat-icon  class="menu-trigger">menu</mat-icon>
        </div>

        <!-- <div class="chat-icon-bg">
        <mat-icon class="chat-icon">chat</mat-icon>
      </div> -->

        <span class="exact-title">Otter AI</span>
      </div>

      <!-- Desktop Header Actions -->
      <div *ngIf="!isMobile" class="header-actions">
        <button class="exact-btn logout" (click)="logout()">
          <span class="material-icons">logout</span> Logout
        </button>
      </div>

    </div>

    <!-- Mobile dropdown -->
    <div *ngIf="isMobile && menuOpen" class="mobile-menu">
      <button class="exact-btn new no-break" (click)="clearSelection()">
        <span class="material-icons">group</span> New Interview
      </button>

      <button class="exact-btn logout" (click)="logout()">
        <span class="material-icons">logout</span> Logout
      </button>
    </div>
  </div>


  <!-- Dashboard Content -->
  <div class="dashboard-content">


    <!-- Sidebar -->
    <!-- SIDEBAR (fully hidden when closed) -->
    <aside class="sidebar" [class.open]="menuOpen">
      <div class="sidebar-content">

        <ul class="menu-list">
             <li class="menu-item" [class.active]="selectedMenu === 'interview-codes'"
            (click)="onMenuSelect('interview-codes')">
            <mat-icon class="menu-icon">description</mat-icon>
            <span class="menu-label">Interview Codes</span>
          </li>
          <li class="menu-item" [class.active]="selectedMenu === 'dashboard'" (click)="onMenuSelect('dashboard')">
            <mat-icon class="menu-icon">grid_view</mat-icon>
            <span class="menu-label">Activity Logs</span>
          </li>
          <li class="menu-item" [class.active]="selectedMenu === 'streaming-metrics'" (click)="onMenuSelect('streaming-metrics')">
            <mat-icon class="menu-icon">speed</mat-icon>
            <span class="menu-label">Streaming Metrics</span>
          </li>


        </ul>

      </div>
    </aside>




    <main class="dashboard-main">
      <!-- DASHBOARD SECTION -->


      <ng-container *ngIf="selectedMenu === 'dashboard'">
        <ng-container *ngIf="!selectedUser">
          <div class="section-header">
            <div class="header-left">
              <h1 class="section-title">Activity Logs</h1>
            </div>
            <div class="header-right">
              <div class="search-box">
                <span class="material-icons search-icon">search</span>
                <input type="text" class="search-input" placeholder="Search by name..." [(ngModel)]="searchText" (input)="onSearchChange($event)" />
              </div>
            </div>
          </div>

          <div class="card">

            <div class="table-wrapper">
              <div class="table-scroll">
                <table>
                  <thead>
                    <tr>
                      <th>User Name</th>
                      <th>Email</th>
                      <th>Last Login</th>
                      <th>Location</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Skeleton loading rows -->
                    <ng-container *ngIf="logsLoading">
                      <tr *ngFor="let item of [1,2,3,4,5,6,7,8]; let i = index" class="skeleton-row" [style.animation-delay]="i * 80 + 'ms'">
                        <td><div class="skeleton-cell skeleton-name"></div></td>
                        <td><div class="skeleton-cell skeleton-email"></div></td>
                        <td><div class="skeleton-cell skeleton-date"></div></td>
                        <td><div class="skeleton-cell skeleton-location"></div></td>
                        <td><div class="skeleton-cell skeleton-btn"></div></td>
                      </tr>
                    </ng-container>
                    <!-- Actual data rows -->
                    <ng-container *ngIf="!logsLoading">
                      <tr *ngFor="let log of sortedLogs">
                        <td>{{ logUsers[log.loginUserId]?.name || '-' }}</td>
                        <td>{{ logUsers[log.loginUserId]?.email || '-' }}</td>
                        <td>{{ formatTimestamp(log.loginTime) }}</td>
                        <td>
                          {{ log.location ? cleanLocation(log.location) : (logUsers[log.loginUserId]?.location ?
                          cleanLocation(logUsers[log.loginUserId]!.location) : '-') }}
                        </td>
                        <td>
                          <button class="view-btn" (click)="viewUserAudit(log)">View</button>
                        </td>
                      </tr>
                      <tr *ngIf="logs.length === 0">
                        <td colspan="5" class="empty-row">No logs found.</td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>


            <!-- Pagination -->
            <div class="pagination-bar" *ngIf="logs.length > 0">
              <div class="pagination-pages" *ngIf="logsTotalPages > 1">
                <span
                  *ngFor="let p of paginationPages"
                  class="page-btn"
                  [class.active]="p === logsPage"
                  [class.ellipsis]="p === '...'"
                  (click)="goToPage(p)">
                  {{ displayPage(p) }}
                </span>
              </div>
              <div class="page-size-select">
                <span class="page-size-label">Rows:</span>
                <div class="dropdown" [class.open]="pageSizeDropdownOpen" (click)="togglePageSizeDropdown($event)">
                  <span class="dropdown-value">{{ logsSize }}</span>
                  <span class="dropdown-arrow">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </span>
                  <ul class="dropdown-menu" [class.show]="pageSizeDropdownOpen">
                    <li *ngFor="let size of pageSizeOptions" (click)="selectPageSize(size, $event)">{{ size }}</li>
                  </ul>
                </div>
              </div>
            </div>



          </div>
          <!-- end card -->

        </ng-container>
        <ng-container *ngIf="selectedUserLoading">
          <div class="loading-container" style="display: flex; justify-content: center; align-items: center; min-height: 300px;">
            <app-spinner [show]="true"></app-spinner>
          </div>
        </ng-container>
        <ng-container *ngIf="selectedUser && !selectedUserLoading">
          <app-user-audit-detail [user]="selectedUser" (back)="handleAuditBack()"></app-user-audit-detail>
        </ng-container>
      </ng-container>

      <!-- INTERVIEW CODES SECTION -->
      <!-- INTERVIEW CODES SECTION -->
      <ng-container class="interview-codes-section" *ngIf="selectedMenu === 'interview-codes'">
        <app-template-selection></app-template-selection>
      </ng-container>

      <ng-container *ngIf="selectedMenu === 'streaming-metrics'">
        <app-streaming-metrics></app-streaming-metrics>
      </ng-container>


    </main>
  </div>
</div>